/**
 * Promise Based Ajax helper methods powered by jQuery.ajax
 */

const GET = 'GET';
const GET_SCRIPT = 'GET_SCRIPT';
const PATCH = 'PATCH';
const PATCH_JSON = 'PATCH_JSON';
const POST = 'POST';
const POST_JSON = 'POST_JSON';
const PUT = 'PUT';
const PUT_JSON = 'PUT_JSON';
const DELETE = 'DELETE';

const DEFAULTS = {
  dataType: 'json', // tells the server what kind of response it will accept in return
  converters: {
    // Simple way to enable jQuery Ajax to handle
    // Content-Type: 'application/json' with no body (e.g. 202, 204, 400, and etc)
    'text json': function parseJson(response) {
      return !response ? null : JSON.parse(response);
    },
  },
};

function ensurePromiseLikeInterface(deferred) {
  if (typeof deferred.catch !== 'function') {
    // Add a catch method with the .fail() implementation
    deferred.catch = deferred.fail.bind(deferred);

    // Ensure every .then() call returns a deferred object with a catch method
    const originalThen = deferred.then.bind(deferred);
    deferred.then = (...args) => {
      const nextDeferred = originalThen(...args);
      return ensurePromiseLikeInterface(nextDeferred);
    };
  }

  return deferred;
}

const createRequester = method => (url, data, options) => {
  if (typeof url !== 'string' && process.env.NODE_ENV !== 'production') {
    return console.error(
      `Expected url argument of request.${method.toLowerCase()} to be of type ` +
        `'string' but instead received '${typeof url}'`,
    );
  }
  const config = {
    GET: {
      cache: false,
    },
    GET_SCRIPT: {
      dataType: 'script',
    },
    PATCH_JSON: {
      contentType: 'application/json',
      data: JSON.stringify(data),
    },
    POST_JSON: {
      contentType: 'application/json',
      data: JSON.stringify(data),
    },
    PUT_JSON: {
      contentType: 'application/json',
      data: JSON.stringify(data),
    },
  };

  const type = method.match(/([a-z]+)(_.+)?/i)[1];
  const requestConfig = { url, data, type, ...config[method], ...options };

  const deferred = $.ajax({ ...DEFAULTS, ...requestConfig });

  return ensurePromiseLikeInterface(deferred);
};

export default {
  get: createRequester(GET),
  getScript: createRequester(GET_SCRIPT),
  patch: createRequester(PATCH),
  patchJSON: createRequester(PATCH_JSON),
  post: createRequester(POST),
  postJSON: createRequester(POST_JSON),
  delete: createRequester(DELETE),
  put: createRequester(PUT),
  putJSON: createRequester(PUT_JSON),
};
